import { buildLegacyDocument } from "./buildLegacyDocument";
import { TEditorConfiguration } from "./documents/editor/core";
import EMPTY_EMAIL_MESSAGE from "./emptyEmailDocument";
import { patchDocumentHeaderNavBorders } from "./patchHeaderNavBorder";

interface LoadedTemplate {
  template?: string | null;
  template_json?: TEditorConfiguration | null;
}

export function resolveInitialDocument(
  loadedTemplate?: LoadedTemplate | null
): TEditorConfiguration {
  if (!loadedTemplate) {
    return EMPTY_EMAIL_MESSAGE;
  }

  if (loadedTemplate.template_json) {
    return patchDocumentHeaderNavBorders(loadedTemplate.template_json);
  }

  if (loadedTemplate.template) {
    return buildLegacyDocument(loadedTemplate.template);
  }

  return EMPTY_EMAIL_MESSAGE;
}

export function isLegacyTemplate(loadedTemplate?: LoadedTemplate | null) {
  return Boolean(
    loadedTemplate &&
      !loadedTemplate.template_json &&
      loadedTemplate.template
  );
}
